import { react, useState } from "react";
import { MdClose } from "react-icons/md";

import { updateFlyerNotification } from "../../Redux/Actions/notification";

function FlyerNotification({ closeFlyerNotification, data, history, openForm }) {
  const [isUpdated, setUpdated] = useState(false);

  const updateStatus = () => {
    let payload = {
      notificationIds: [data?.id],
    };
    updateFlyerNotification(payload).then((res) => {
      if (res?.data) {
        // window.location.reload();
        closeFlyerNotification(null);
        setUpdated(true);
      }
    });
  };

  const clickedOnImage = () => {
    updateStatus();
    if (!data?.isDeepLink) {
      history.push(`/flyerNotifications`);
    } else {
      openForm();
    }
  };

  if (data?.url == null) {
    updateStatus();
  }
  return (
    <div>
      {data?.url != null && (
        <div style={{ position: "fixed", zIndex: 1051, left: "40%" }}>
          (
          <div>
            <div
              className="modal"
              style={{
                display: "block",
                alignItems: "center",
              }}
            >
              <div
                className="modal-dialog"
                style={{ maxWidth: "300px", left: "-10%", top: "10%" }}
              >
                <div
                  className="modal-content"
                  style={{
                    maxWidth: "300px",
                    left: "40%",
                    top: "30%",
                    maxHeight: "550px",
                  }}
                >
                  <div className="modal-body">
                    <div className="d-flex" style={{ justifyContent: "end" }}>
                      <img
                        src="/Assets/remove.svg"
                        height={"25px"}
                        width={"25px"}
                        style={{ marginBottom: "5px", cursor: "pointer" }}
                        onClick={updateStatus}
                      />
                    </div>
                    <div
                      className="d-flex"
                      style={{ justifyContent: "center", cursor: "pointer" }}
                      onClick={clickedOnImage}
                    >
                      <img
                        src={data?.url}
                        style={{
                          maxHeight: "400px",
                          maxWidth: "250px",
                          paddingBottom: "10px",
                        }}
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-backdrop show"></div>
          </div>
          )
        </div>
      )}
    </div>
  );
}

export default FlyerNotification;
